import type { BrandTokens, ThemePreset } from "../types";
import { createCleanTheme } from "./clean";
import { createMaterialTheme } from "./material";
import { createMinimalTheme } from "./minimal";
import { createNocturneTheme } from "./nocturne";
import { createAtlasTheme } from "./atlas";
import { createCircuitTheme } from "./circuit";

export const themePresets: Record<ThemePreset, (brand: BrandTokens) => ReturnType<typeof createMaterialTheme>> = {
  material: createMaterialTheme,
  clean: createCleanTheme,
  minimal: createMinimalTheme,
  nocturne: createNocturneTheme,
  atlas: createAtlasTheme,
  circuit: createCircuitTheme
};
